import { memo, FC, useMemo } from 'react'

import { useAuth } from '@sportworld/js-sdk/src/context/authContext'

import {
  UserCreditsBadge,
  UserCreditsWrapper,
} from '@/components/MainSidebar/styles'
import { icons } from '@/constants/icons'
import { getCurrentLanguage } from '@/i18n'
import useStore from '@/store/useStore'

type Props = { isCentered: boolean }

const UserCreditsRaw: FC<Props> = ({ isCentered }) => {
  const { isRegisteredUser } = useAuth()
  const userCreditsWallets = useStore(
    (state) => state.common.userCreditsWallets,
  )

  const { swCreditCount, promotionCreditCount } = useMemo(() => {
    let swCreditCount = 0
    let promotionCreditCount = 0

    userCreditsWallets?.forEach((wallet) => {
      const count = wallet.availableCreditCount ?? 0
      if (wallet.uniqueId === 'sportworld-credits') {
        swCreditCount = count
      } else if (wallet.uniqueId?.startsWith('promotion')) {
        promotionCreditCount += count
      }
    })
    return {
      swCreditCount,
      promotionCreditCount,
    }
  }, [userCreditsWallets])

  const fontSizeScale = useMemo(() => {
    const maxCount = Math.max(
      swCreditCount.toString().length,
      promotionCreditCount.toString().length,
    )
    const calculatedSize = maxCount > 6 ? 6 / maxCount : 1
    return Math.max(calculatedSize, 0.5)
  }, [swCreditCount, promotionCreditCount])

  if (!isRegisteredUser) {
    return null
  }

  const hidePromotionCredits = true
  const language = getCurrentLanguage()

  return (
    <UserCreditsWrapper $isCentered={isCentered} $fontSizeScale={fontSizeScale}>
      <UserCreditsBadge>
        {swCreditCount.toLocaleString(language)}
        <img src={icons.register.swCredits} alt="" />
      </UserCreditsBadge>
      {!hidePromotionCredits && (
        <UserCreditsBadge $isPromotionCredits>
          {promotionCreditCount.toLocaleString(language)}
          <img src={icons.register.swPromotionCredits} alt="" />
        </UserCreditsBadge>
      )}
    </UserCreditsWrapper>
  )
}

export const UserCredits = memo(UserCreditsRaw)
